import { render } from "./App.vue?vue&type=template&id=4a955009"
const script = {}

import "./App.vue?vue&type=style&index=0&id=4a955009&lang=css"

import exportComponent from "E:\\Andrei\\munca\\Isoletta\\isoletta-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__